import { useMutation } from "react-query";
import InternalStudyListService from "@services/internal-study-list-service";
import { DownloadProtocolFileParams } from "@interfaces/store/internal-list-store-types";

export const useDownloadFileXmlMutation = () => {
  return useMutation((data: DownloadProtocolFileParams) =>
    InternalStudyListService.downloadXml(data)
  );
};

export const useDownloadFileProtocolMutation = () => {
  return useMutation((data: DownloadProtocolFileParams) =>
    InternalStudyListService.downloadProtocol(data)
  );
};
